module.exports = __webpack_public_path__ + "img/taux-clics.731f1e8.png";